// @ts-nocheck
import { Card, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import Warning from '@material-ui/icons/Warning.js';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { CUSTOM_ACTION_BUTTONS_ACTIONS, CUSTOM_ACTION_BUTTONS_ICONS, ORANGE, PERMISSIONS, PERMISSION_ENTITIES, RED } from '../../../_config/consts.js';
import AbilityProvider from '../../../permissionsUtils/AbilityProvider.js';
import MDButton from '../../MDButton/MDButton.jsx';
import Permission from '../../Permission/Permission.jsx';
import FormFlatContainer from '../Elements/FormFlatContainer.jsx';
import IconSelectorField from '../Elements/IconSelectorField.jsx';
import CustomField from '../Fields/CustomField.jsx';
import TranslatableOption from '../Fields/TranslatableOption.jsx';
import InfoSection from '../../InfoSection/InfoSection.jsx';



const onRenderParameters = (props) => {
  const { fields } = props;
  const numberOfParameters = _.size(fields);
  return (
    <div style={{ marginTop: 10 }}>
      {fields && _.map(fields, (parameter, index) => (
        <div key={`parameter${index + 1}`} style={{ width: 'fit-content', marginBottom: 20 }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', paddingRight: 10 }}>
            <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
              <div style={{ paddingLeft: 0, width: 300 }}>
                <Entity
                  id={`parameters[${index}].name`}
                  name={`parameters[${index}].name`}
                  componentClass={Field}
                  componentAttribute="placeholder"
                  entity="insertParameterName"
                  title={<Entity entity="parameterName" />}
                  component={CustomField}
                  type="text"
                />
              </div>
              <div style={{ paddingLeft: 0, width: 300 }}>
                <Entity
                  id={`parameters[${index}].value`}
                  name={`parameters[${index}].value`}
                  componentClass={Field}
                  componentAttribute="placeholder"
                  entity="insertParameterValue"
                  title={<Entity entity="parameterValue" />}
                  component={CustomField}
                  type="text"
                />
              </div>
            </div>
            <IconButton
              style={{ marginTop: 25 }}
              onClick={(e) => {
                e.stopPropagation();
                fields.remove(index);
              }}
            >
              <DeleteIcon style={{ color: RED, fontSize: 20 }} />
            </IconButton>
          </div>
        </div>
      ))}
      <Card
        style={{ height: 35, marginBottom: 20, marginTop: 20, padding: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', width: 'fit-content', cursor: 'pointer' }}
        className="card card-rounded"
        onClick={() => {
          fields.push({});
        }}
      >
        <AddIcon style={{ color: '#4DB6AC', marginRight: 15, fontSize: 20 }} />
        <h4 style={{ fontWeight: 'bold', marginTop: 0, marginBottom: 1, fontSize: 16 }}><Entity entity="addParameter" /></h4>
      </Card>
    </div>
  );
};

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'required';
  }
  if (!values.action) {
    errors.action = 'required';
  }
  if (!values.icon) {
    errors.icon = 'required';
  }
  return errors;
};

@reduxForm({ form: 'CustomExploreButtonForm', validate })
@connect(state => ({ form: state.form.CustomExploreButtonForm }))
class CustomExploreButtonForm extends React.Component {
  render() {
    const customFieldsActionsOptions = [
      { label: 'selectCustomActionButtonAction', value: '' },
      ..._.map(CUSTOM_ACTION_BUTTONS_ACTIONS, customAction => (
        { label: L20NContext.getSync('customExploreButonsActions', { type: CUSTOM_ACTION_BUTTONS_ACTIONS[customAction]}), value: CUSTOM_ACTION_BUTTONS_ACTIONS[customAction] }
      )),
    ];

    const { onValidateForm, onDeleteActionButton, form } = this.props;
    const isEditing = form && form.values && form.values.id;
    const selectedAction = form && form.values && form.values.action;
    return (
      <FormFlatContainer title="customExporeActionButton" titleContainerStyle={{ marginBottom: 20 }} containerStyle={{  marginRight: 25, marginLeft: 15}}>
        <Entity
          componentClass={Field}
          name="title"
          componentAttribute="placeholder"
          entity="insertCustomExploreButtonName"
          title={<Entity entity="customExploreButtonName" />}
          component={CustomField}
          type="text"
          mandatory
        />
        <Field
          id="action"
          name="action"
          title={<Entity entity="customActionButtonAction" />}
          component={CustomField}
          className="form-control-select"
          componentClass="select"
          mandatory
          hideErrorLabel={false}
          disabled={isEditing}
        >
          {_.map(customFieldsActionsOptions, action =>
            <Entity
              key={action.value}
              componentClass={TranslatableOption}
              value={action.value}
              componentAttribute="text"
              entity={action.label}
            />)
          }
        </Field>
        {selectedAction === CUSTOM_ACTION_BUTTONS_ACTIONS.URL_WEBVIEW || selectedAction === CUSTOM_ACTION_BUTTONS_ACTIONS.URL_EXT_BROWSER ? (
          <Entity
            name="url"
            title={<Entity entity="customExploreButtonUrl" />}
            entity="insertCustomExploreButtonUrl"
            componentAttribute="placeholder"
            component={CustomField}
            componentClass={Field}
            type="text"
          />
        ) : null}
        {selectedAction === CUSTOM_ACTION_BUTTONS_ACTIONS.OPEN_NATIVE_VIEW ? (
          <>
            <Entity
              name="nativeViewName"
              title={<Entity entity="customExploreButtonNativeView" />}
              entity="insertCustomExploreButtonNativeView"
              componentAttribute="placeholder"
              component={CustomField}
              componentClass={Field}
              type="text"
            />
            <div style={{ marginTop: 20 }}>
              <h4 style={{ fontSize: 16, color: '#3f3f3f', fontWeight: 'bold', marginBottom: 5 }}>
                <Entity entity="parameters" />
              </h4>
              <h4 style={{ fontSize: 14, color: '#3f3f3f', marginBottom: 10 }}>
                <Entity entity="parametersDescription" />
              </h4>
              <FieldArray
                name="parameters"
                component={onRenderParameters}
              />
            </div>
          </>
        ) : null}
        <Field
          id="icon"
          name="materialIconName"
          title={<Entity entity="customExploreButtonIcon" />}
          icons={CUSTOM_ACTION_BUTTONS_ICONS}
          component={IconSelectorField}
          disabled={isEditing}
          multiSelect={false}
          mandatory
          containerStyle={{ marginTop: 20 }}
        />
        {isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
            <Warning style={{ fontSize: 15, color: ORANGE }} />
            <h5 style={{ margin: 0, marginLeft: 5 }}>{<Entity entity="customFieldTypeEditForbidden" />}</h5>
          </div>
        ) : null}

        <InfoSection
          title="customFieldTypeEditForbidden"
          gravity="warning"
          titleStyle={{ fontWeight: 'normal' }}
        />
        <Permission do={[PERMISSIONS.UPDATE]} on={PERMISSION_ENTITIES.SMART_LOCK} abilityHelper={AbilityProvider.getAbilityHelper()}>
          <MDButton
            title={<Entity entity="save" />}
            onClick={() => onValidateForm()}
          />
        </Permission>
        {isEditing && onDeleteActionButton ? (
          <MDButton
            title={<Entity entity="deleteActionButton" />}
            backgroundColor={RED}
            containerStyle={{ marginTop: 20 }}
            onClick={() => onDeleteActionButton()}
          />
        ) : null}
      </FormFlatContainer>
    );
  }
} 

export default CustomExploreButtonForm;
